import $ from 'jquery';
import AOS from 'aos';

interface JobsResponse {
  success: boolean;
  data: {
    jobs: string;
    pagination?: string;
    count: number;
  };
}

$(() => {
  const $jobsSection = $('#jobs');

  if ($jobsSection.length) {
    const $searchInput = $('#job-search-input');
    const $searchForm = $('#job-search-form');
    const $jobsList = $('#jobs-list');
    const $jobsLoader = $('#jobs-loader');
    let $paginationContainer = $('#jobs-pagination');
    const $jobsCountWrapper = $jobsSection.find('.jobs-count-wrapper');
    const ajaxUrl = $jobsSection.data('ajax-url') as string;
    const nonce = $jobsSection.data('nonce') as string;
    const textSingular = $jobsSection.data('text-singular') as string;
    const textPlural = $jobsSection.data('text-plural') as string;

    let searchTimeout: ReturnType<typeof setTimeout> | null = null;
    let currentRequest: JQuery.jqXHR | null = null;

    const showLoader = (): void => {
      $jobsList.hide();
      $jobsLoader.css('display', 'flex');
    };

    const hideLoader = (): void => {
      $jobsLoader.hide();
      $jobsList.css('display', 'grid');
    };

    const filterJobs = (page: number = 1, search: string = ''): void => {
      if (currentRequest) {
        currentRequest.abort();
      }

      showLoader();

      currentRequest = $.ajax({
        url: ajaxUrl,
        method: 'POST',
        data: {
          action: 'filter_jobs',
          nonce: nonce,
          paged: page,
          search: search,
        },
      })
        .done((response: JobsResponse) => {
          if (response.success) {
            $jobsList.html(response.data.jobs);

            $paginationContainer = $('#jobs-pagination');

            if (response.data.pagination) {
              if ($paginationContainer.length === 0) {
                const $newPagination = $('<div>', {
                  class: 'pagination',
                  id: 'jobs-pagination',
                  html: response.data.pagination,
                });
                $jobsSection.append($newPagination);
              } else {
                $paginationContainer
                  .find('.nav-links')
                  .html(response.data.pagination);
              }
            } else {
              if ($paginationContainer.length) {
                $paginationContainer.remove();
              }
            }

            const count = response.data.count;
            const $jobsCountParagraph = $jobsCountWrapper.find('.jobs-count');
            const $jobsCountNumber = $jobsCountParagraph.find('.jobs-count-number');
            const countText = count > 1 ? textPlural : textSingular;

            if ($jobsCountNumber.length) {
              $jobsCountNumber.text(count);
              $jobsCountParagraph.html(
                `<span class="jobs-count-number">${count}</span> ${countText}`
              );
            }

            AOS.refresh();

            $('html, body').animate(
              {
                scrollTop: $jobsSection.offset()!.top,
              },
              400
            );
          }
        })
        .fail((xhr: JQuery.jqXHR, status: string) => {
          if (status !== 'abort') {
            // eslint-disable-next-line no-console
            console.error('Erreur lors du filtrage des offres:', status);
          }
        })
        .always(() => {
          hideLoader();
          currentRequest = null;
        });
    };

    const attachPaginationListeners = (): void => {
      $(document)
        .off('click', '#jobs .pagination a.page-numbers')
        .on('click', '#jobs .pagination a.page-numbers', function (e: JQuery.ClickEvent) {
          e.preventDefault();

          const $link = $(this);
          let page: number | string = 1;
          const href = $link.attr('href');

          if (href) {
            const urlParts = href.split('?')[1];
            if (urlParts) {
              const queryString = urlParts.split('#')[0];
              const params = new URLSearchParams(queryString);
              page = params.get('jobs_page') || 1;
            }
          }

          if ($link.hasClass('prev') || $link.hasClass('next')) {
            const $currentPage = $jobsSection.find('.pagination .current');
            if ($currentPage.length) {
              const currentPageNum = parseInt($currentPage.text(), 10);
              page = $link.hasClass('prev')
                ? currentPageNum - 1
                : currentPageNum + 1;
            }
          }

          const searchValue = ($searchInput.val() as string).trim();
          filterJobs(Number(page), searchValue);
        });
    };

    $searchInput.on('input', function () {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      const searchValue = ($(this).val() as string).trim();

      if (searchValue.length === 0 || searchValue.length >= 2) {
        searchTimeout = setTimeout(() => {
          filterJobs(1, searchValue);
        }, 300);
      }
    });

    $searchForm.on('submit', function (e: JQuery.SubmitEvent) {
      e.preventDefault();
      const searchValue = ($searchInput.val() as string).trim();
      filterJobs(1, searchValue);
    });

    attachPaginationListeners();
  }
});
